<template>
    <div class="yh-page" v-loading="downloading">
        <el-card>
            <el-divider content-position="left">基础信息</el-divider>
            <el-form ref="form" :model="form" :validate-on-rule-change="false" label-position="right"
                label-width="160px" >
                <el-row>
                <el-col :span="6">
                    <el-form-item label="创建人">
                        {{ form.creator_name }}
                        <!-- <el-input type="text" v-model="form.creator_name" style="width: 160%;" disabled /> -->
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label="创建时间">
                        {{ form.create_time }}
                        <!-- <el-input type="text" v-model="form.create_time" disabled /> -->
                    </el-form-item>
                </el-col>
                </el-row>

                <el-row>
                <el-col :span="6">
                    <el-form-item label="活动期数">
                        <el-input type="text" v-model="form.activity_name" style="width: 120%;" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label="批次">
                        <el-input type="text" v-model="form.batch" style="width: 120%;" disabled />
                    </el-form-item>
                </el-col>
                </el-row>
                <el-col :span="18">
                    <el-form-item label="活动期限">
                        <el-input type="text" v-model="form.begin_date" style="width: 36%;" disabled /> 
                        至 
                        <el-input type="text" v-model="form.end_date" style="width: 36%;" disabled />
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="18">
                    <el-form-item label="活动结束时间">
                        <el-input type="text" v-model="form.end_date" style="width: 48%;" disabled />
                    </el-form-item>
                </el-col> -->
                <el-col :span="18">
                    <el-form-item label="出单情况">
                        {{ policy_info_text }}
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="付款事由">
                        <el-input type="textarea"
                            :autosize="{ minRows: 2, maxRows: 8}"
                            v-model="form.payment_cause"
                            style="width: 74%;"
                            disabled
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="记账公司名称">
                        <el-input type="text" v-model="form.bookkeeping_company_name" style="width: 48%;" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="加盖印章名称">
                        <el-input type="text" v-model="form.seal_name" style="width: 70%;" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="大桥保费">
                        <el-input type="text" v-model="form.big_premium" style="width: 48%;" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="小桥保费" >
                        <el-input type="text" v-model="form.small_premium" style="width: 48%;" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="支付日期">
                        <el-date-picker
                            v-model="form.pay_date"
                            type="date"
                            disabled
                            format="yyyy 年 MM 月 dd 日"
                            value-format="yyyy-MM-dd"
                            placeholder="选择支付日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="付款方式">
                        <el-input type="text" v-model="form.payment_type" style="width: 70%;" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="对方账户名">
                        <el-input type="text" v-model="form.account_info.name" style="width: 70%;" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="对方账号">
                        <el-input type="text" v-model="form.account_info.number" style="width: 70%;" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="对方开户行">
                        <el-input type="text" v-model="form.account_info.bank" style="width: 70%;" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="18">
                    <el-form-item label="拒绝原因" v-if="form.status === 2">
                        <el-input type="text" v-model="form.reason" style="width: 48%;" disabled />
                    </el-form-item>
                </el-col>
                <template v-if="form.is_all_account">
                    <el-col :span="18">
                        <el-form-item label="确认收款人">
                            <el-input type="text" v-model="form.account_auditor_name" style="width: 48%;" disabled />
                        </el-form-item>
                    </el-col>
                    <el-col :span="18">
                        <el-form-item label="确认收款时间">
                            <el-input type="text" v-model="form.account_time" style="width: 48%;" disabled />
                        </el-form-item>
                    </el-col>
                </template>
                <template v-if="[1, 3].indexOf(form.status) !== -1">
                    <el-col :span="18">
                        <el-form-item label="同意申请人">
                            <el-input type="text" v-model="form.agree_auditor_name" style="width: 48%;" disabled />
                        </el-form-item>
                    </el-col>
                    <el-col :span="18">
                        <el-form-item label="同意申请时间">
                            <el-input type="text" v-model="form.agree_time" style="width: 48%;" disabled />
                        </el-form-item>
                    </el-col>
                </template>
                <template v-if="[3].indexOf(form.status) !== -1">
                    <el-col :span="18">
                        <el-form-item label="付款人">
                            <el-input type="text" v-model="form.payer_name" style="width: 48%;" disabled />
                        </el-form-item>
                    </el-col>
                    <el-col :span="18">
                        <el-form-item label="付款时间">
                            <el-input type="text" v-model="form.payment_time" style="width: 48%;" disabled />
                        </el-form-item>
                    </el-col>
                </template>

                <el-col :span="18">
                    <el-form-item label="申请文件" prop="attachments">
                    <attachment-list 
                        object-type="group_insurance.insuranceissueapply" :object-id="form.id" :file-list="file_list"
                        :attachment-name="attachment_name"
                        @removed="loadFileList('group_insurance.insuranceissueapply', form.id)"></attachment-list>
                    <el-button type="primary" size="small" @click="handleUpload" class="ml-2">上传</el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <!--创建按钮-->
            <div>
                <el-button type="primary" @click="goBack">返回</el-button>
                <el-button type="primary" @click="doExport" v-show="$perm(['group_insurance.update_insurance_issue_apply'])">导出财务报表</el-button>
            </div>
            <br>
            <div>
                <el-button type="primary" @click="handleSuccess" v-if="opera_type === 'SuccessApply'">审核通过</el-button>
                <el-button type="primary" @click="handleReject" v-if="opera_type === 'SuccessApply'">审核不通过</el-button>
                <el-button type="primary" @click="handleExportIssuePaymentApply(form.id)" v-if="form.status === 3">导出支付申请凭证</el-button>
            </div>
            <upload-dialog ref="upload" :object-name="form.batch" :file-type-list="file_type_list"
                object-type="group_insurance.insuranceissueapply" :object-id="form.id" :append-to-body="true"
                :default-issue-date.sync="default_issue_date" 
                @appended="handleAppended" @uploaded="loadFileList('group_insurance.insuranceissueapply', form.id)">
            </upload-dialog>
            <el-dialog :visible.sync="SuggestionVisible" width="50%">
                <el-form ref="refuse_reason" :model="refuse_reason" label-width="120px">
                <el-form-item label="拒绝原因" width="50%">
                    <el-input type="textarea"  :rows="10" v-model="refuse_reason"></el-input>
                </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addMessage">确 定</el-button>
                </span>
            </el-dialog>
        </el-card>
    </div>
</template>

<script>

import {IssueApplyInfo,successIssueApply,refuseIssueApply, exportIssuePaymentApply} from '@/api/group-insurance'
import UploadDialog from "@/components/UploadDialog"
import { fetchFileTypeList, getObjectFileAll } from '@/api/common'
import AttachmentList from "@/components/AttachmentList"
import { GetFinanceReport } from '@/api/group-insurance'
import { getTitleText } from "@/views/pb/common/func"


export default {
    name: "IssueApplyDetail",
    components: {
        UploadDialog,
        AttachmentList,

    },
    computed: {
        attachment_name: function () {
        let name = this.form.batch
        return (name + ".zip");
        }
    },
    data() {
        return {
            ship_name:"",
            member:"",
            creator:"",
            file_name:"",
            apply_time:"",
            default_issue_date: '',
            file_type_list: [],
            file_list: [],
            is_member:true,
            form:{},
            apply_info:{},
            opera_type:"",
            downloading:false,
            SuggestionVisible:false,
            refuse_reason:"",
            pdfname:'',
            query_form:{},
            loadingText: '正在加载数据，请稍等...',
            policy_info_text: ''
        };
    },

    methods: { 
        doExport(command) {
            this.$message.success("导出操作已提交后台处理，导出完成会收到通知")
            this.query_form.activity = this.activity
            this.query_form.policy = this.batch
            GetFinanceReport(this.query_form)
              .then(res => {
              let link = document.createElement('a')
              link.style.display = 'none'

              let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
              link.href = URL.createObjectURL(blob)
              link.download = this.file_name +  '.xlsx'
              document.body.appendChild(link)

              link.click()
              URL.revokeObjectURL(blob)
              document.body.removeChild(link)
              this.downloading = false
            })
            .catch(error => {
              this.downloading = false
              this.$error_message(error)
            })
        },
        getData(id){
            IssueApplyInfo({"id":id}).then(resp => {
                this.form = resp
                this.file_name = resp.file_name
                if (Object.keys(resp.policy_info).length > 0) {
                    const options = { 
                        year: 'numeric', 
                        month: '2-digit', 
                        day: '2-digit' 
                    };
                    const formattedDates = [];
                    resp.policy_info.content.forEach(item => {
                        const date = new Date(item)
                        formattedDates.push(new Intl.DateTimeFormat('en-CA', options).format(date));
                    })
                    this.policy_info_text = `共 ${resp.policy_info.num} 份保单，起保日期为：${formattedDates.join('、 ')}`
                }
                else {
                    this.policy_info_text = `共 1 份保单，起保日期为：${resp.begin_date}`
                }
            })
            .catch(error => {
                this.loading = false
                this.$message.error(error)
            })
        },
        handleAppended(fileList) {
            this.file_list = this.file_list.concat(fileList)
            },
        loadFileList(object_type, object_id) {
            getObjectFileAll(object_type, object_id).then(res => {
                this.file_list = res
                this.file_list.forEach(item => {
                    this.$set(item, 'checked', true)
                })
            })
            .catch(error => {
                this.$error_message(error)
            })
        },
        handleUpload() {
            this.$refs.upload.handleOpen()
            },
        addMessage(){
            var msg = '是否拒绝该申请？'
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
            }).then(() => {
                this.SuggestionVisible = false
                refuseIssueApply({'id':this.form.id,'reason':this.refuse_reason})
                .then(() => {
                    this.$message({
                    type: 'success',
                    message: '拒绝成功!'
                    })
                    this.$router.push({ name: 'IssueApplyList' })   
                })
                .catch(error => {
                    this.$message.error(error)
                })
            })
        },
        goBack: function(){
            this.$router.go(-1)
            },
        handleReject() {
            this.SuggestionVisible = true
        },
        handleSuccess() {

          var msg = '是否通过该申请？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            this.downloading = true
            successIssueApply({'id':this.form.id})
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '通过成功!'
                })
                this.downloading = false
                this.$router.push({ name: 'IssueApplyList' }) 
              })
              .catch(error => {
                this.$message.error(error)
                this.is_member = false
              })
          })
        },
        handleExportIssuePaymentApply(id) {
            this.downloading = true
            exportIssuePaymentApply(id).then(res => {
                let link = document.createElement('a')
                link.style.display = 'none'
                let blob = new Blob([res])
                link.href = URL.createObjectURL(blob)
                
                link.download = '桥梁险支付申请.pdf'
                document.body.appendChild(link)

                link.click()
                URL.revokeObjectURL(blob)
                document.body.removeChild(link)
                this.downloading = false
            }).catch(error => {
                this.downloading = false
                this.$error_message(error)
            })
        },
        loadData() {
            this.getData(this.id)
            if (this.opear_type  !== 'ApplySuccess'){
                this.loadFileList('group_insurance.insuranceissueapply', this.id)
            }
            
            let p0 = fetchFileTypeList({ file_type: "group_ins|sc|bc" })
            Promise.all([p0])
                .then(res => {
 
                this.file_type_list = res[0]

                })
                .catch(error => {
                this.loading = false
                this.$message.error(error)
                })
                },  
    },
    beforeRouteLeave(to, from, next) {
        if (to.name != 'actList') {
            window.localStorage.removeItem('query')
        }
        next()
    },
    created() {
        this.opera_type = this.$route.query.type
        this.id = this.$route.query.id  
        this.batch =  this.$route.query.batch  
        this.activity =  this.$route.query.activity 
        this.loadData()

    },
};
</script>

